import React from 'react';
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';

import './Bocker.css'

const bocker = props => (
  <div className="column-big-container">

    <div className="book-image">
      <Image src="images/book/kojan_paket_liggande_2024.jpg" responsive/>
    </div>

    <div className="column-big-info">
      <h3>Bok 1</h3>

      <p><b>Snick & Snack Vännerna i Kungaskogen bygger en koja</b> är titeln på den första boken om ”Vännerna i Kungaskogen”.
        Sagan tar upp viktiga värdegrunder som vänskap, djur, natur, empati, mot utanförskap och mobbning, att vara
        ”schysst och en bra kompis”.  I sagans och underhållningens form ger boken prov på hur man ska vara mot varandra och
        bygger in moral- och etikbegrepp i saga, sång, musik och dialog. Snick och Snack och alla bokens karaktärer har gått
        rätt in i barnens hjärta.Bilderna i boken är fantastiskt fint gjorda i akvarell och med figurerna i heltäckande färger.</p>

      <p>Handling: I Kungaskogen ska kompisarna ekorren Snick och igelkotten Snack bygga en koja tillsammans, men de har inga verktyg.
        Raffe Räv har en verktygslåda, som han kan låna ut. Men bara kanske. Han kanske ska ha dem själv. Kaninen Bitis från Dalarna
        vill också vara med och leka. Snick, Snack och Raffe retas och säger att kojan är hemligt område, förbjudet för Kaniner.
        Älgen Älgvis (från Norrland) får reda på att Bitis är ledsen och talar om för de andra att så får man inte göra, det
        kallas för mobbning. Alla ska få vara med och leka! Skatan Hotta (från storstan) kommer plötsligt och tar Raffes hammare från
        kojan hem till sitt bo. Hon måste lämna tillbaka hammaren och säger förlåt och får vara med och bygga koja. Papegojan Maraca
        (från Argentina) har flytt från regnskogen som skövlats i Sydamerika. Hon hamnar i ett förskräckligt oväder i Kungaskogen
        och undsätts av vännerna. Nu är även hon med och leker. Maraca berättar om varför hon ser annorlunda ut. Kojan blir
        klar och vännerna firar med ett hejdundrande kalas. Det bästa på hela kojbygget var att Snick och Snack fick så många vänner.</p>

      <h4>Musiken</h4>

      <p>Med boken följer en 2 timmars lång inspelning med berättelse (Börje Ahlstedt), dialoger (alla 7 karaktärerna) och 12 sångnummer.
        Sångerna anknyter till de värdegrunder som sagan tar upp. All musik är nyskriven på 2000 talet med tydliga och lättsjungna melodier
        i olika musikstilar. Barnen identifierar sig i sångtexterna som de lätt lär sig utantill. Sångerna är redan barnviseklassiker och
        sjungs t ex på avslutningar, teatrar och familjeevents. Sångerna finns också separat som noter i boken och på QR koder (tidigare CD skivor).
        Läs om alla 25 st som deltagit i produktionen i <Link to="/medverkande" className="med-upp">Medverkanden</Link>.</p>

      <h4>Författare</h4>

      <p>Författare till berättelsen och sångtexterna är Lisa Grane (dos Santos) född och uppvuxen i Falsterbo med en jur.
        kand examen från Lunds Universitet. Under hela sin uppväxt har Lisa skrivit och hade alltid bästa betyg i svenska.
        Lisa är numera bosatt i Stockholm där hon fortsätter skrivandet i kombination med sitt yrke inom juridik. Mer om Lisa
        och illustratör finns i <Link to="/upphovspersoner" className="med-upp">Upphovspersoner</Link>.</p>

      <a href="https://soundcloud.com/wasamusic/kungaskogen-kojan-trailer" target="_blank" rel="noopener noreferrer">Kojan Trailer </a>
    </div>

    <div className="line" />

    <div className="book-image">
      <Image src="images/book/utflykt_paket_liggande_2024.jpg" responsive/>
    </div>

    <div className="column-big-info">
      <h3>Bok 2</h3>

      <p><b>Snick & Snack Vännerna i Kungaskogen går på utflykt</b> är titeln på den andra boken om ”Vännerna i Kungaskogen”.
        Den här boken också den i ”Elsa Beskows format” är större än den första och är indelad i LEK I KOJAN, UTFLYKT
        I SKOGEN och GRODAN GRONILLAS HÅLLBARA SKOGSCAFÉ. Berättelserna bygger in viktiga moral- och etikbegrepp, vikten
        att vara goda vänner, samarbeta och lösa konflikter. I denna bok tydliggörs också livsstil och hälsa. Hållbart
        och miljö ges extra utrymme i berättelsen. Vännerna från kojbygget i Kungaskogen får ytterligare två kompisar.
        Man blir snäll av boken säger barnen. De välgjorda och vackra akvarellbilderna styrker berättelsen med tydligt
        bild - och kroppsspråk. Sagorna om Vännerna i Kungaskogen håller på att bli en skandinavisk barnklassiker.</p>

      <p>Handling: Vännerna i Kungaskogen, Snick, Snack, Raffe, Bitis, Hotta och Maraca bestämmer sig för att göra en
        utflykt i Kungaskogen. Alla packar saker som kan vara bra att ha med sig på en utflykt. Och så händer det förstås
        en massa saker; Snick och Snack blir osams om en kotte, Snick går vilse, Raffe slår sig, Snack blir retad för
        han inte kan simma. På sin utflykt träffar vännerna den nya kompisen Grodan Gronilla från Gotland. Gronilla är
        en påhittig och idérik groda som driver ett hållbart skogscafé i Kungaskogen. Gronilla lagar nyttiga soppor,
        närodlar grönsaker och har uppfunnit en maskin som tar hand om skräp och sortera sopor, en Multimiljömaskin.
        Kojkompisarna lär sig mycket om miljön. Raffe vill också bygga en Multimiljömaskin.</p>

      <h4>Musiken</h4>

      <p>Sagan om Vännerna i Kungaskogen är en saga som låter. Med boken följer en 3 timmars lång inspelning med
        berättelse, dialoger och 19 sångnummer. Sång och musik anknyter till de värdegrunder och händelser som
        sagan tar upp. All musik är nyskriven på med tydliga och lättsjungna melodier i olika musikstilar.
        Barnen identifierar sig i sångtexterna som de lätt lär sig utantill. Sångerna finns också separat som noter i boken och på QR koder (tidigare CD skivor).
        Läs om alla 25 st som deltagit i produktionen i <Link to="/medverkande" className="med-upp"> Medverkanden</Link>.</p>



      <h4>Författare</h4>

      <p>Författare till berättelsen och sångtexterna är samma som i första boken, Lisa Grane (dos Santos).
        Lisa jobbade i flera år med detta manus som hon tycker blev väldigt heltäckande och som barn i sin
        vardagsvärld lätt kan identifiera sig i. Mer om Lisa och illustratör finns i <Link to="/upphovspersoner"
        className="med-upp">Upphovspersoner</Link>.</p>

      <a href="https://soundcloud.com/wasamusic/kungaskogen-utflykt-trailer" target="_blank" rel="noopener noreferrer">Utflykt Trailer </a>
      <a href="https://soundcloud.com/wasamusic/kungaskogen-snick-slinga-utflykt" target="_blank" rel="noopener noreferrer">Snick om Utflykt </a>

      <h4>Mera sagor om Vännerna i Kungaskogen</h4>

      <p>Fler högläsningssagor om ”Vännerna i Kungaskogen” finns i Access Kungaskogen. Fler böcker planeras. Barn och
        vuxna är alltid välkomna till förlaget med sina egna idéer till förslag på handling och berättelser om ”Vännerna
        i Kungaskogen”. I Kungaskogen får alla vara med!</p>
    </div>
  </div>
);

export default bocker;
